import React, { memo } from "react";
import { Box } from "@/components/atoms/Box";

/**
 * Props for the SafeAndroidMarkdownView component
 */
interface SafeAndroidMarkdownViewProps {
  processedContent: React.ReactNode;
}

/**
 * Presentation component for rendering processed markdown content.
 *
 * @remarks
 * This container must NOT carry `flex-1`. It renders inside a chat bubble whose
 * height is content-driven, and `flex: 1` sets `flexBasis: 0` — on Yoga that
 * left every child `Text` laid out at **zero height**, so an Ask Gemini answer
 * on Android rendered as a blank grey bubble. Verified on a Pixel 7 emulator:
 * with `flex-1` the accessibility tree held the full answer with
 * `boundsInParent: Rect(0, 0 - 677, 0)` and `visible: false` on every node;
 * without it the same message renders normally. Web/iOS were unaffected because
 * they use `MarkdownRenderer`, not this component. Let the content size itself.
 * @param root0 - Component props
 * @param root0.processedContent - Pre-processed React elements from markdown parsing
 */
const SafeAndroidMarkdownView: React.FC<SafeAndroidMarkdownViewProps> = ({
  processedContent,
}) => <Box className="px-1 py-2">{processedContent}</Box>;

SafeAndroidMarkdownView.displayName = "SafeAndroidMarkdownView";

export default memo(SafeAndroidMarkdownView);
